import { apiFetch } from './api';
import { normalizeBudgetRates, type BudgetRates } from './proposalBudget';

// One immutable snapshot per browser page, shared by editor and client tabs.
// Concurrent requests deduplicate; failures clear the promise for a later retry.
let snapshot: Promise<BudgetRates> | null = null;
export function getBudgetExchangeRates(): Promise<BudgetRates> {
  if (!snapshot) {
    snapshot = apiFetch('/api/public/budget/exchange-rates', { skipRedirect: true })
      .then(async response => {
        if (!response.ok) throw new Error('Exchange rates unavailable');
        const body = await response.json();
        const rates = normalizeBudgetRates(body.data?.rates);
        if (!body.success || !rates) throw new Error('Invalid exchange rate response');
        return Object.freeze({ ...rates, rates: Object.freeze({ ...rates.rates }) });
      }).catch(error => { snapshot = null; throw error; });
  }
  return snapshot;
}
